/* Cross-sell upsell logic for checkout Order Summary.
   Detects cart context (trumpet/sax/trombone/guitar) and picks a random
   relevant accessory the customer doesn't already have in their cart.

   - Innovation accessories get a 20% discount (calculated from product.price)
   - Real Books get NO discount (full price)
   - The upsell rotates randomly on each render so different customers see different offers
*/

// Pools per detected instrument context, in priority order.
// First entry is the "default" if random pick fails.
// Each entry: { slug, discount } where discount is 0..1
var UPSELL_POOLS = {
  trumpet: [
    { slug: 'muteclip', discount: 0.20 },
    { slug: 'belloflex-mute', discount: 0.20 },
    { slug: 'armis-bellguard', discount: 0.20 },
    { slug: 'armis-leather-trumpet-sleeve', discount: 0.20 },
    { slug: 'brass-plank', discount: 0.20 },
    { slug: 'real-book-vol-1-bb', discount: 0 },
    { slug: 'new-real-book-vol-1-bb', discount: 0 },
  ],
  sax: [
    { slug: 'real-book-vol-1-eb', discount: 0 },
    { slug: 'saxolift', discount: 0.20 },
    { slug: 'real-book-vol-1-bb', discount: 0 },
    { slug: 'brass-plank', discount: 0.20 },
    { slug: 'new-real-book-vol-1-eb', discount: 0 },
    { slug: 'new-real-book-vol-1-bb', discount: 0 },
  ],
  trombone: [
    { slug: 'trombuddy', discount: 0.20 },
    { slug: 'brass-plank', discount: 0.20 },
    { slug: 'real-book-vol-1-bass', discount: 0 },
  ],
  guitar: [
    { slug: 'real-book-vol-1-c', discount: 0 },
    { slug: 'real-book-vol-2-c', discount: 0 },
    { slug: 'new-real-book-vol-1-c', discount: 0 },
  ],
  // Generic fallback when we can't detect instrument
  any: [
    { slug: 'muteclip', discount: 0.20 },
    { slug: 'brass-plank', discount: 0.20 },
    { slug: 'real-book-vol-1-bb', discount: 0 },
    { slug: 'real-book-vol-1-eb', discount: 0 },
  ],
};

// Detect cart context based on variants/categories of items in cart
function detectContext(cartItems) {
  for (var i = 0; i < cartItems.length; i++) {
    var item = cartItems[i];
    var v = (item.variant || '').toLowerCase();
    var slug = (item.product && item.product.slug || '').toLowerCase();
    if (v.indexOf('trumpet') !== -1 || v.indexOf('flugelhorn') !== -1 || v.indexOf('french horn') !== -1) return 'trumpet';
    if (v.indexOf('sax') !== -1 || v.indexOf('clarinet') !== -1) return 'sax';
    if (v.indexOf('trombone') !== -1) return 'trombone';
    if (v.indexOf('guitar') !== -1 || v.indexOf('bass') !== -1) return 'guitar';
    // Fallback: detect by product slug for non-NoteTurner items
    if (slug.indexOf('saxolift') !== -1 || slug.indexOf('sax') !== -1) return 'sax';
    if (slug.indexOf('trombuddy') !== -1) return 'trombone';
    if (slug.indexOf('belloflex') !== -1 || slug.indexOf('muteclip') !== -1 || slug.indexOf('armis') !== -1) return 'trumpet';
  }
  return 'any';
}

// Pick a random eligible upsell (one not already in cart).
// Seed by a stable hash so the upsell doesn't change every render of the same cart.
function pickUpsell(cartItems, allProducts) {
  var context = detectContext(cartItems);
  var pool = UPSELL_POOLS[context] || UPSELL_POOLS.any;
  var cartSlugs = {};
  for (var i = 0; i < cartItems.length; i++) {
    cartSlugs[(cartItems[i].product && cartItems[i].product.slug) || ''] = true;
  }
  var eligible = pool.filter(function(p) {
    if (cartSlugs[p.slug]) return false;
    var product = allProducts.find(function(x) { return x.slug === p.slug; });
    return !!product && !product.outOfStock;
  });
  if (eligible.length === 0) return null;

  // Stable selection: pick based on hash of slugs in cart so it doesn't flicker on rerender
  var hash = 0;
  for (var j = 0; j < cartItems.length; j++) {
    var s = (cartItems[j].product && cartItems[j].product.slug) || '';
    for (var k = 0; k < s.length; k++) hash = ((hash << 5) - hash + s.charCodeAt(k)) | 0;
  }
  var idx = Math.abs(hash) % eligible.length;
  var pick = eligible[idx];
  var product = allProducts.find(function(x) { return x.slug === pick.slug; });
  if (!product) return null;
  var originalPrice = product.price || 0;
  var finalPrice = pick.discount > 0
    ? Math.round((originalPrice * (1 - pick.discount)) * 100) / 100
    : originalPrice;
  return {
    product: product,
    originalPrice: originalPrice,
    finalPrice: finalPrice,
    discount: pick.discount,
    isDigital: (product.category === 'sheet-music'),
  };
}

export { pickUpsell, detectContext };
